import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const OrganizationIcon = ({ kind, store, size, className, showPubIcon = true, showPubStore }) => {
  const isPublisher = kind === 'unified_publisher' || kind === 'publisher';
  const isSdk = kind === 'sdk';
  const iconClass = () => {
    switch (store) {
      case 'google_play':
        return 'hicon-play text-xs';
      case 'itunes_connect':
        return 'hicon-apple text-xs';
      case 'both':
      case 'unified':
        return 'hicon-unified text-xs';
      default:
        return 'hicon-company text-md';
    }
  };

  return (
    <div
      className={cx(
        'd-flex align-items-center justify-content-center text-truncate organization-icon',
        className
      )}
    >
      {(kind === 'company' || showPubStore) && (
        <i
          className={cx('d-flex store-icon', iconClass())}
          data-testid="company-icon"
          style={{ marginRight: 0, ...(size && { fontSize: size, width: size }) }}
        />
      )}

      {isPublisher && showPubIcon && (
        <i
          className="d-flex store-icon hicon-publisher text-md"
          data-testid="publisher-icon"
          style={{
            marginRight: showPubStore && 8,
            marginLeft: showPubStore && 8,
            ...(size && { fontSize: size, width: size }),
          }}
        />
      )}
      {isSdk && (
        <i
          className="d-flex store-icon hicon-finance-sdk text-md"
          data-testid="sdk-icon"
          style={{ ...(size && { fontSize: size, width: size }) }}
        />
      )}
    </div>
  );
};

OrganizationIcon.propTypes = {
  store: PropTypes.string,
  className: PropTypes.string,
  kind: PropTypes.string,
  size: PropTypes.number,
  showPubIcon: PropTypes.bool,
  showPubStore: PropTypes.bool,
};

export default OrganizationIcon;
